<template>
    <div id="main" class="StoreInfo">
        <navigation-bar Back Bell :name="storeInfo.brandName +' '+ storeInfo.name" v-if="!isWeb"/>
        <div class="main">
            <div class="container">
                <!--todo 標籤功能，有被設定此標籤的會員才會看到-->
                <div class="table-tag" v-show="$public.notNull(tagList)" >
                    <span v-for="(tag, index) in tagList" :key="index" :style="{backgroundColor:`rgba(${tag.colorRGB})`, color:`${tag.colorRGB==='255,255,255'?'#000':'#fff'}`, border:`${tag.colorRGB==='255,255,255'?'solid 1px':'none'}`}">{{ tag.tagName }}</span>
                </div>

                <div class="marquee" v-if="announcementList.length !== 0 && !isWeb">
                    <div class="loudly"/>
                    <div class="text">
                        <div class="marquees">
                        <span v-for="(item, index) in announcementList" :key="index"
                              @click="onClickFuncBtn('bulletin', {itemId: item.id})">
                            {{announcementList[index].newsTicker}}
                        </span>
                        </div>
                    </div>
                </div>

                <div :class="{'main-block': isWeb}">

                    <div :class="{'info-block': isWeb}">
                        <div :class="{'line-block': isWeb}">
                            <div class="shadow-box">
                                <!--識別圖-->
                                <div class="identify-block" v-if="!isWeb">
                                    <img :src="couponLogoImage"
                                         v-for="(couponLogoImage, index) in storeInfo.couponLogoImageList"
                                         :key="index"
                                         class="identify-logo">
                                </div>
                                <banner :list="storeImgAry" :store="Number(1)" v-if="!isWeb"/>

                                <div class="card-body">
                                    <div class="list-style border-0 pb-0 pt-0">
                                        <div class="content">
                                            <div class="d-flex">
                                                <div class="flex-grow-1 phone-btn" v-if="storeInfo.tel !== ''">
                                                    <a @click="$public.callTel(storeInfo.tel)" >
                                                        <img :src="isWeb ? require('@/assets/images/phone_dark.svg') : require('@/assets/images/phone.svg')" />
                                                        <span>{{storeInfo.tel}}</span>
                                                    </a>
                                                </div>
                                                <div class="distance" v-if="storeInfo.distance !== '' && !isWeb">
                                                    <i class="el-icon-location-outline"></i>
                                                    <span>{{storeInfo.distance}}</span>
                                                </div>
                                            </div>
                                            <div class="location-btn">
                                                <a @click="onClickLocationBtn" v-if="storeInfo.city !== ''">
                                                    <img :src="isWeb ? require('@/assets/images/location_dark.svg') : require('@/assets/images/location_blue.svg')" />

                                                    <span>{{storeInfo.city+storeInfo.township+storeInfo.address}}</span>
                                                </a>
                                            </div>

                                            <template v-if="isWeb">
                                                <div class="branch-btn"
                                                     @click="onClickFuncBtn('usefulStore', {brandId: storeInfo.brandId})"
                                                     v-show="isShowStoreInfo"
                                                >
                                                    <a>
                                                        <img src="@/assets/images/branch_dark.svg" alt="分店資訊">
                                                        <span>分店資訊</span>
                                                    </a>
                                                </div>
                                                <!--todo FB、IG、YT等連結-->
                                                <Links v-if="storeInfo.websiteStatus" :socialWebsites="storeInfo.websites" :socialWebsitesStatus="storeInfo.websiteStatus" :iconType="iconType" isFlat/>

                                            </template>
                                        </div>
                                    </div>

                                    <el-button class="join" v-if="!isWeb" v-show="isLogin" :class="{active:isMember}">
                                        <p v-show="isMember">
                                            <i class="el-icon-check"/>
                                            <span>已為會員</span>
                                        </p>
                                        <p v-show="!isMember" @click="onClickAddMember()">
                                            <img src="@/assets/images/join_store.svg">
                                            <span>加入會員</span>
                                        </p>
                                    </el-button>

                                </div>
                            </div>
                            <div class="d-flex mt-2" :class="storeInfo.websites===''?'':storeInfo.websites==='[]'?'':JSON.parse(storeInfo.websites).length>4?'many-icon': ''">
                                <div class="business-hours" v-show="isShowBusinessHours(storeInfo)"  @click="showBusiness=!showBusiness">
                                    <i class="el-icon-time"/>
                                    <span class="status">{{storeInfo.businessHours.businessStatusString}}</span>{{storeInfo.businessHours.endBusinessTimePeriodString}}
                                    <i class="el-icon-caret-bottom" v-show="!showBusiness"></i>
                                    <i class="el-icon-caret-top" v-show="showBusiness"></i>
                                </div>

                                <!--todo FB、IG、YT等連結-->
                                <Links v-if="storeInfo.websiteStatus && !isWeb" :socialWebsites="storeInfo.websites" :socialWebsitesStatus="storeInfo.websiteStatus" :iconType="iconType" isFlat/>
                            </div>
                            <el-row type="flex" v-show="showBusiness">
                                <ul class="text-left business-hours">
                                    <li class="week">星期一 <span v-html="showBusinessTime(storeInfo.businessHours.monday)"></span></li>
                                    <li class="week">星期二 <span v-html="showBusinessTime(storeInfo.businessHours.tuesday)"></span></li>
                                    <li class="week">星期三 <span v-html="showBusinessTime(storeInfo.businessHours.wednesday)"></span></li>
                                    <li class="week">星期四 <span v-html="showBusinessTime(storeInfo.businessHours.thursday)"></span></li>
                                    <li class="week">星期五 <span v-html="showBusinessTime(storeInfo.businessHours.friday)"></span></li>
                                    <li class="week">星期六 <span v-html="showBusinessTime(storeInfo.businessHours.saturday)"></span></li>
                                    <li class="week">星期日 <span v-html="showBusinessTime(storeInfo.businessHours.sunday)"></span></li>
                                </ul>
                            </el-row>
                            <!--todo 外送資訊(備註) -->
                            <div class="takeout-list single" v-show="isShowRemark(storeInfo)" @click="isOpen">
                                <div class="title">
                                    <div v-if="!isNoteIconError">
                                        <img :src="isNoteIconEmpty(storeInfo.noteIcon) ? require('@/assets/images/remark/remark_'+storeInfo.noteIcon+'.svg'):''" @error="onImgError"/>{{storeInfo.title}}
                                    </div>
                                    <div v-else>
                                        <img :src="require('@/assets/images/remark/remark_01.svg')"/>{{storeInfo.title}}
                                    </div>
                                </div>
                                <div class="con" v-html="getRemark(storeInfo)"/>
                                <div class="icon-arrow">
                                    <i class="el-icon-caret-bottom"/>
                                </div>
                            </div>

                            <div class="wrap-menu" v-if="!isWeb">
                                <div class="item" @click="onClickFuncBtn('usefulStore', {brandId: storeInfo.brandId})" v-show="isShowStoreInfo">
                                    <img src="@/assets/images/store/store.svg">
                                    <span>門市資訊</span>
                                </div>
                                <div class="item" v-show="showHidden" >
                                    <img src="@/assets/images/store/comment.svg">
                                    <span>評論</span>
                                </div>
                                <div class="item" v-show="storeInfo.onlineOrderStatus && this.$public.isCordova()" @click="onClickFuncBtn('order')">
                                    <img src="@/assets/images/store/order.svg">
                                    <span>點餐</span>
                                </div>
                                <div class="item" v-show="showHidden" @click="onClickFuncBtn('waiting')">
                                    <img src="@/assets/images/store/book.svg">
                                    <span>候位</span>
                                </div>
                                <div class="item" v-if="isOpenBooking" @click="onClickFuncBtn('booking')">
                                    <img src="@/assets/images/store/book.svg">
                                    <span>訂位</span>
                                </div>
                                <div class="item" v-if="isOpenBooking" @click="onClickFuncBtn('bookingRecord')">
                                    <!--todo 有新訂位狀態的小紅點-->
                                    <div v-if="showDot" class="dot"/>
                                    <img src="@/assets/images/store/book_record.svg">
                                    <span>訂位狀態</span>
                                </div>
                                <div class="item" v-if="reserveBasicStatus" @click="onClickFuncBtn('reserve')">
                                    <img src="@/assets/images/store/reservation.svg">
                                    <span>預訂</span>
                                </div>
                                <div class="item" @click="onClickFuncBtn('bulletin')">
                                    <img src="@/assets/images/store/bulletin.svg">
                                    <span>公告</span>
                                </div>
                                <div class="item" v-show="isOpenFeedback" @click="onClickFuncBtn('reflect')">
                                    <!--todo 小紅點-->
                                    <div v-if="showUnreadMsgDot" class="dot"/>
                                    <img src="@/assets/images/store/opinion.svg">
                                    <span>意見反映</span>
                                </div>
                                <div class="item" v-if="isArticle" @click="onClickFuncBtn('column')">
                                    <img src="@/assets/images/store/column.svg">
                                    <span>專欄</span>
                                </div>
                                <div class="item" v-if="isOpenQA" @click="onClickFuncBtn('question')">
                                    <img src="@/assets/images/store/question.svg">
                                    <span>常見問題</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div :class="{'store-block': isWeb}">
                        <div class="about mt-4" v-show="isShowAbout(storeInfo)">
                            <category-header title="關於我們" class="ml-0 mb-2" v-if="!isWeb"/>

                            <div class="text-content" v-html="displayText" />
                            <div :class="aboutOpen?'read-more-close':'read-more'"
                                 v-if="(aboutText.length > 45 && !this.isWeb) || (aboutText.length > 45 && this.mobileType)"
                                 @click="[aboutOpen=!aboutOpen, sendClickFuncGAEvent('click_關於我們')]">
                                {{ aboutOpen ? '向上收合' : '繼續閱讀' }}
                            </div>

                        </div>

                        <div class="YT-video mt-4" v-show="isShowVideo(videoUrl)">
                            <div class="video-container">
                                <iframe id="store-video-frame" width="560" height="315" src="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"/>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <category-content v-show="storeInfo.photoStatus">
                <category-header title="PHOTOS"/>
                <item-grid v-show="$public.notNull(storeInfo.menuImageAry)">
                    <vue-preview :slides="photoArray"/>
                </item-grid>
            </category-content>
            <category-content v-if="!isWeb" v-show="storeInfo.ticketInfoAry !== undefined && storeInfo.ticketInfoAry.length > 0">
<!--                <category-header @click="onClickCouponLink" title="優惠活動"/>-->
                <category-header :to="{name: 'TicketList', query:{p: ticketListParameter}}" title="優惠活動"/>
                <item-grid>
                    <div class="menu-block coupon" v-for="(item, index) in storeInfo.ticketInfoAry" :key="index" >
                        <div @click="onClickTicketDetail(item)" class="cover3">
                            <el-image :src="item.titleImage"  fit="cover"></el-image>
                            <div class="mask">
                                <p class="time">{{item.name}}</p>
                                <p class="name" v-html="item.content"/>
                                <img src="@/assets/images/cut1.svg">
                            </div>
                        </div>
                    </div>
                </item-grid>
            </category-content>
            <category-content v-show="storeInfo.recommendStatus">
                <category-header :to="!isWeb?{name: 'CommodityList',query:{id: storeInfo.id, type: 'store'}}: null" title="推薦商品" v-show="storeInfo.recommendList !== undefined && storeInfo.recommendList.length > 0" />
                <item-grid>
                    <div class="goods-item" v-for="(item, index) in storeInfo.recommendList.slice(0,9)" :key="'recommend'+index"
                         @click="[sendClickFuncGAEvent('click_推薦商品'), onClickProposeItem(item.id)]">
                        <div class="cover">
                            <img :style="{backgroundImage: 'url(' + item.image + ')' }" class="size-cover">
                        </div>
                        <div class="title">{{item.name}}</div>
                        <div class="fee" v-if="item.price>0">${{item.price}}</div>
                    </div>
                </item-grid>
            </category-content>

        </div>

        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
        <comm-dialog :value="dialog.isShowDialog"
                     :outerContent="dialog.dialogMsg"
                     :isCancel="dialog.cancelable"
                     @result="onCommDialogClose"/>
        <!--todo 未登入提醒-->
        <comm-dialog :value="isShowLogin"
                     :outerContent="'請先登入'"
                     @result="onShowLoginDialogClose"/>
        <join-member-dialog :value="joinDialog.isShowDialog"
                            :outerContent="joinDialog.dialogTitle"
                            :mainContent="joinDialog.dialogMsg"

                            :isCancel="joinDialog.cancelable"
                            @result="onJoinMemberDialogClose"/>

        <!--推薦商品手勢下滑關閉-->
        <PullDownClose v-if="isShowPullDown" @close="closePullDown" :class="{'big-pull': isTypeWeb==='MealInfo'}">
            <MealInfo :dataTokenWeb="dataTokenWeb" isWeb class="content" v-if="isShowPullDown && isTypeWeb==='MealInfo'"/>
            <UsefulStoreList :dataTokenWeb="dataTokenWeb" isWeb class="content" v-if="isShowPullDown && isTypeWeb==='UsefulStoreList'"/>
        </PullDownClose>

        <toast/>
    </div>
</template>

<script>
    import CategoryContent from '@/components/category/Content.vue';
    import CategoryHeader from '@/components/category/Header.vue';
    import ItemGrid from '@/components/category/ItemGrid.vue';
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import * as constDefine from '@/store/constDefine';
    import Banner from '@/components/BannerSlider.vue';
    import CommDialog from "@/components/CommDialog";
    import JoinMemberDialog from "../../components/JoinMemberDialog";
    import auth from "@/util/auth";
    import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";
    import Links from "../../views/complex/components/Links";
    import Analytics from "@/util/analytics";
    import PullDownClose from "@/components/PullDownClose";
    import MealInfo from "@/views/store/MealInfo";
    import UsefulStoreList from "@/views/store/UsefulStoreList"
    export default {
        name: "StoreInfo",
        components: {
            JoinMemberDialog,
            Toast,
            CategoryContent,
            CategoryHeader,
            ItemGrid,
            Banner,
            CommDialog,
            Links,
            PullDownClose,
            MealInfo,
            UsefulStoreList,
        },
        data() {
            return {
                showDot:false,
                isLoading: false,
                isLogin: this.$auth.isAdminLogin(true),
                isMember: undefined,        //是否爲會員
                id: Number(this.$route.query.id),
                showUnreadMsgDot: false,        //是否有未讀回應？
                storeImgAry: [],
                storeInfo: {
                    id: 0,

                    address: '',
                    bookingStatus: 0,       // 不明？
                    bookingUrl: '',         // 線上訂位網址
                    brandId: undefined,
                    brandName: '',
                    businessHours: {
                        monday: [],
                        tuesday: [],
                        wednesday: [],
                        thursday: [],
                        friday: [],
                        saturday: [],
                        sunday: [],
                        businessStatusString: '',
                        endBusinessTimePeriodString: '',
                    },
                    city: '',
                    couponInfoAry: [],          //店家優惠券清單
                    ticketInfoAry: [],          //店家搶券清單
                    couponLogoImageList: [],
                    description: '',            //描述
                    descriptionStatus: false,   //是否顯示描述
                    distance: '',               //距離標示文字
                    editBookingUrl: '',         //線上訂位網址
                    facebook: '',
                    googleMapUrl: '',        //google地圖 url
                    imageAry: [],
                    imgUrl: '',             //店家 logo
                    instagram: '',
                    lat: 0,
                    lng: 0,
                    maxPrice: 0,
                    menuImageAry: [],
                    minPrice: 0,
                    name: '',
                    noteAry: [],      //備註
                    noteIcon: '',             //備註的 icon
                    noteStatus: false,        //備註是否顯示
                    officialWebsite: '',
                    officialWebsiteStatus: false,
                    onlineOrderStatus: false,
                    photoStatus: false,
                    priceStatus: false,
                    recommendList: [],          //推薦商品區
                    recommendStatus: false,     //推薦商品開啓狀態
                    tel: '',
                    tel2: '',
                    title: '',      //備註的標題
                    township: '',
                    youtube: '',        //影片網址
                    websites: '',   //社群連結網址
                    websiteStatus: false,   //社群連結開關

                },
                iconType: 'isFlat', //社群連結Icon樣式
                // storeInfo: undefined,
                announcementList: [],           //公告
                tagList: [],                    //user 要在店家顯示的 tag，另外抓
                isShowBusiness: '',
                showBusiness: false,
                showHidden: false,
                imgDialog: {
                    imgShow: false,
                    imgSrc: '',
                },
                videoUrl: '',
                aboutOpen: false,       //關於我們看更多
                aboutText: '',         //關於我們轉純文字字串
                scrollTop: '',
                scrollHeight:'',
                googleMapLat: 0,        //開啓 google map用的 lat
                googleMapLng: 0,        //開啓 google map用的 lng
                googleMapStoreInfoData: 0,      //開啓 google map用的商店資訊
                photoArray: [],         //菜單放大圖用
                //dialog 用
                dialog: {
                    isShowDialog: false,
                    dialogMsg: '',
                    cancelable: false,
                },
                //dialog 用
                joinDialog: {
                    isShowDialog: false,
                    dialogTitle: '',
                    dialogMsg: '',
                    cancelable: false,
                },
                // bookingUrl:'',
                // editBookingUrl:'',
                encryptUrlSegment:'',           //預約訂位用的加密參數
                userId:'',

                isOpenBooking:'',               //是否開啓訂位按鈕
                isOpenFeedback:'',              //是否開啓意見反映按鈕
                isOpenQA: false,
                //請先登入彈框
                isShowLogin: false,

                //載圖錯誤旗標
                isNoteIconError: false,
                isArticle: false,

                isShowStoreInfo: false,
                reserveBasicStatus: false,

                analytics: null,

                storeCode: this.$route.params.storeCode, //從router寫入的
                isWeb: false,
                isShowPullDown: false,
                isTypeWeb: '',
                dataTokenWeb: '',
                mobileType: '',

            }
        },
        computed: {
          ticketListParameter: function() {
            let obj = {
              storeId: this.storeInfo.id
            }
            return this.$crypto.encryptObject(obj);
          },
            displayText() {
                //字數大於45才出現縮排，且網頁桌面端一律不出現縮排
                const desc = this.storeInfo.description || ''
                const desc2 = this.aboutText || ''
                return ( this.aboutOpen || desc2.length <= 45 || (this.isWeb && !this.mobileType)) ? desc : desc2.substring(0, 45) + '...';
            }
        },
        created() {
            //單店網頁版用
            let routerName = this.$route.name;
            if (routerName === "WebStoreInfo" && this.storeCode !== "") {
                this.isWeb = true
                this.$http.fetch`GetStoreIdByStoreCode${{
                    'storeCode': this.storeCode,
                }}
                ${json => {
                    if (json.status) {
                        this.id = json.data
                        this.setupData();
                    } else {
                        this.$router.push({name: 'Error'})
                    }
                }}`;
            } else if (this.id === undefined || this.id === 0) {
                this.$public.showNotify("id錯誤", false);
            } else {
                this.setupData();

                // this.isJoinMember(this.id)
                //     .catch( (error) => {
                //         self.$store.commit(mutationTypes.SHOW_TOAST, error);
                //     });
            }

            this.analytics = Analytics.getInstance(this.$route, this.$route.name);
        },
        mounted() {

            this.getIsBookingRecord();

            const self = this
            self.mobileType = window.innerWidth < 768;
            window.onresize = () => {
                self.mobileType = window.innerWidth < 768;
            };

        },
        methods: {

            setupData: function () {

                let self = this;
                self.getAnnouncement(self.id)
                    .then(
                        //這樣的用法 (外面沒有函式括號，裡面沒有 return) 就是直接串接 Promise，會等待 Promise回傳結果
                        self.getGpsLocation
                    )
                    .then( position => {
                        //Promise內是非同步執行
                        //如果 then裡面是用函式形態包起來的話，函式內也會變成非同步執行
                        //若 then裡面是函式形態，但還要接 Promise的話，要以 return回傳 Promise物件，才會等待 Promise的回傳
                        //沒有 return的話， then不會等待 Promise的回覆，直接往下進行
                        if (self.$public.notNull(position)) {
                            return self.callGetStoreInfoByIdApi( self.id, position.coords.longitude, position.coords.latitude);
                        } else {
                            return self.callGetStoreInfoByIdApi( self.id, 0, 0);
                        }

                    })
                    .then( () => {
                        //像這邊的用法 (外面有函式括號，但裡面沒有用 return)， then就不會等待 isJoinBrandMember回傳結果
                        //then 呼叫了 isJoinBrandMember以後，就直接往下繼續執行了
                        if (self.isLogin) {
                            return self.isJoinBrandMember(self.storeInfo.brandId);
                        }
                    })
                    .then( () => {
                        if (self.isLogin) {
                            self.callIsUnreadFeedbackApi(self.id);
                        }
                    })
                    .then( () => {
                        if (self.isLogin) {
                            if (self.isMember) {
                                //抓會員 tag
                                self.getUserStoreTag(self.id);
                            }
                            self.combineBookingParams();
                        }

                        //發出GA事件記錄
                        self.sendClickFuncGAEvent("open_store_info");
                    })
                    .then( () => {
                        //跳頁處理，點擊跳頁連結進來的，在這邊檢查是不是店家功能相關的跳頁
                        if (self.isLogin) {
                            //先把參數轉成的物件存起來
                            let redirectParam = self.$public.getAppRedirectParam();
                            self.$public.clrAppRedirectParam();
                            if (self.$public.notNull(redirectParam)) {
                                if (redirectParam.action === constDefine.REDIRECT_ACTION_ORDER) {
                                    self.onClickFuncBtn('order');
                                }
                            }
                        }
                    })
                    .catch( (error) => {
                        self.isLoading = false;
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });

            },

            /** 取得目前定位 */
            getGpsLocation: function() {
                let self = this;
                self.isLoading = true;
                return new Promise(function(resolve, reject) {
                    let onSuccess = function (position) {
                        //取得店家資訊
                        self.isLoading = false;
                        resolve(position);
                    };
                    let onError = function (error) {
                        //取得店家資訊
                        // reject(`code: ${error.code} , message:  ${error.message} 。無法定位GPS`);
                        self.isLoading = false;
                        resolve(null);
                    };

                    self.$public.getGpsLocation(onSuccess, onError);
                });
            },

            /** 取得跑馬燈(公告) 內容 */
            getAnnouncement: function(storeId) {
                let self = this;
                self.isLoading = true;

                return new Promise(function(resolve, reject) {
                    //取得公告內容
                    self.$http.fetch`GetAnnouncementQueryAllList${{
                        'storeId': storeId,
                    }} ${json => {
                        self.isLoading = false;

                        if (self.$public.notNull(json.data)) {
                            let counter = 0;

                            self.announcementList = json.data;
                            json.data.forEach(function (value, index) {
                                if (index < 5) {
                                    //把原本物件存到陣列，並新增一個 newsTicker變數，當做跑馬燈文字內容
                                    // self.announcementList[index] = value;
                                    self.announcementList[index].newsTicker = "活動公告：" +value.title;
                                    counter++ ;
                                }
                            });


                            if(self.announcementList.length!==0 && !self.isWeb){
                                //要倒數幾秒後才能抓到寬度
                                setTimeout(() => {
                                    const marqueesWidth=document.querySelector('.marquees').offsetWidth
                                    //輪播的秒數
                                    const marqueeTime = (window.innerWidth+marqueesWidth)*.008
                                    self.$el.style.setProperty('--marqueeDistance', `${-marqueesWidth+"px"}`)
                                    self.$el.style.setProperty('--marqueeTime', `${marqueeTime+"s"}`)
                                    document.querySelector('.marquees').style = "opacity:10";

                                }, 100)
                            }
                            resolve();
                        } else {
                            reject();
                        }
                    }}`;
                });
            },

            /** 呼叫 取得店家資訊api */
            callGetStoreInfoByIdApi (storeId, lng, lat) {

                let self = this;
                self.isLoading = true;

                //取得店家資訊
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`GetStoreInfoById${{
                        id: storeId,
                        lng: lng,
                        lat: lat,
                    }} ${json => {
                        self.isLoading = false;

                        if (self.$public.notNull(json.data)) {
                            self.storeInfo = json.data;
                            self.isNoteIconError = false;   //要改變這個數值，才能再讓備註icon重新載入，看看 icon有沒有載入錯誤

                            // self.bookingUrl = json.data.bookingUrl;
                            // self.editBookingUrl = json.data.editBookingUrl;
                            self.isOpenBooking = (json.data.bookingStatus === 1);       // 回傳1 爲開啓訂位
                            self.isOpenFeedback = (json.data.feedbackStatus === 1);       // 回傳1 爲開啓意見反映
                            self.isOpenQA = json.data.qAStatus === 1;
                            self.isArticle = json.data.isArticle;
                            self.reserveBasicStatus = json.data.reserveBasicStatus;

                            self.isShowStoreInfo = json.data.isShowStoreInfo;

                            //影片
                            self.changeVideoUrl(self.storeInfo.youtube);

                            //google地圖 url分析
                            self.analyzeGoogleMapUrl(self.storeInfo.googleMapUrl);

                            //菜單和放大圖使用
                            json.data.menuImageAry.forEach(function (item, index) {
                                const newImg = new Image()
                                newImg.onload = () => {
                                    self.photoArray.push(
                                        {
                                            src: item,//大圖
                                            msrc: item,//小圖
                                            w: newImg.width,//抓圖片原始的寬
                                            h: newImg.height//抓圖片原始的高
                                        }
                                    );
                                }
                                newImg.src = item
                            });


                            if (self.$public.notNull(json.data.imageAry) && json.data.imageAry.length > 0) {
                                //轉換成 BannerSlider 可以用的格式
                                self.storeImgAry = json.data.imageAry.map(function (item, index) {
                                    return {
                                        url: '',
                                        imgUrl: item,
                                    }
                                });
                            }

                            //透過 eventBus發出事件和店家資料給 MainStoreWeb.vue
                            if (self.isWeb) {
                                self.$eventBus.$emit('store-event', self.storeInfo);
                                self.$store.commit(mutationTypes.updateFilterStoreId, self.storeInfo.id);
                            } else {
                                self.$store.commit(mutationTypes.updateFilterStoreId, 0);
                            }
                            resolve();

                        } else {
                            reject(`GetStoreInfoById: 無法取得資料`);
                        }
                    }}`;
                });

            },

            /** 是否有未讀的意見回覆 */
            callIsUnreadFeedbackApi : function(storeId) {
                let self = this
                return new Promise(function(resolve, reject) {
                    self.isLoading = true;
                    self.$http.fetchWithAuth`GetIsUnreadFeedback${{
                        storeId: storeId,
                    }} ${json => {
                        self.isLoading = false;
                        if (self.$public.notNull(json.data)) {
                            self.showUnreadMsgDot = json.data.isUnread;
                        }

                        //完畢
                        resolve();
                    }}`;
                });
            },

            /** 產生訂候位用的參數 */
            combineBookingParams : function() {
                let self = this;
                let usertoken = localStorage.getItem("admin_token");
                let decrypted = self.$crypto.decryptText(usertoken);
                let decrypted_array = decrypted.split(';');

                // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                const userData = getCryptoUserInfo();
                let user_name = userData.name;
                let phone = userData.phone;
                let gender = userData.gender;
                let email = userData.email;


                let encryptString = user_name+";"+phone+";"+gender+";"+email+";"+decrypted_array[0];
                let encryptedString = self.$crypto.encryptText(encryptString);
                let secondEncrypt = encodeURIComponent(encryptedString);
                self.encryptUrlSegment = secondEncrypt;
                self.userId = decrypted_array[0];
            },

            /**取得是否有訂位資料*/
            getIsBookingRecord:function(){
                if (this.isLogin) {
                    let self = this
                    self.isLoading = true;
                    self.$http.fetchWithAuth`GetUserWhetherIsBooking${{
                        'storeId': self.id
                    }} ${json => {
                        self.isLoading = false;

                        self.bookingUrlSet = json.data.editbookingUrl+"/";
                        self.bookingQuantity = parseInt(json.data.dataQuantity)
                        if(self.bookingQuantity>0){
                            self.showDot = true
                        }else{
                            self.showDot = false
                        }
                    }}`;
                }
            },

            /** 顯示訊息 dialog */
            showDialog: function (msg, cancelable = false) {
                this.dialog.cancelable = cancelable;
                this.dialog.dialogMsg = msg;
                this.dialog.isShowDialog = true;
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                this.dialog.isShowDialog = false;
            },
            //請先登入彈框關閉事件
            onShowLoginDialogClose(result){
                this.isShowLogin = false
                if (result) {
                    this.$router.push({name: 'Login'});
                }
            },
            /** 加入會員訊息 dialog */
            showJoinMemberDialog: function (title, msg, cancelable = false) {
                this.joinDialog.cancelable = cancelable;
                this.joinDialog.dialogTitle = title;
                this.joinDialog.dialogMsg = msg;
                this.joinDialog.isShowDialog = true;
            },

            /** JoinMemberDialog 關閉事件 */
            onJoinMemberDialogClose: function(result) {
                this.joinDialog.isShowDialog = false;

                if(result) {
                    if (this.id > 0) {
                        let self = this;
                        self.isLoading = true;
                        //加入會員
                        self.addBrandMember(self.storeInfo.brandId)
                            .then( () => {
                                self.isLoading = false;
                                //加入成功
                                self.showDialog(`加入會員成功`);

                                //發出GA事件記錄
                                self.sendClickFuncGAEvent("join_member");
                            })
                            .catch( (error) => {
                                self.isLoading = false;
                                self.$store.commit(mutationTypes.SHOW_TOAST, error);
                            });
                    }
                }
            },

            /** 開啓訂位網頁 */
            checkNull:function(item){
                try {
                    return this.$public.notNull(item);
                } catch (e) {
                    return false;
                }
            },

            /** 開啓訂位網頁 */
            loadBooking:function(id){
                let urlSet = this.storeInfo.bookingUrl+"/"+this.encryptUrlSegment;
                // this.$public.openUrl(uthis.loadBooking();rlSet);
                // window.open(urlSet);

                let self = this;
                // let browser = this.$public.isCordova()? window.cordova.InAppBrowser: window;
                let browser = this.$public.isCordova()? (this.$public.notNull(window.cordova?.InAppBrowser)?window.cordova.InAppBrowser: window): window;
                //使用 _system的話會呼叫 app外部的 browser來開網頁
                let appInBrowser = browser.open(urlSet, '_blank', 'toolbar=no,location=no' + self.$http.browserOpenFeatures());

                // 注意，這一段是針對使用 InAppBrowser這個套件專用的方法
                //如果是 cordova開啓，就植入 javascript持續取得網頁網址 location.href，
                //直到轉成訂位成功的頁面，再將另一段 javascript植入加入行事曆按鈕中，發射 message給 app接收
                if (this.$public.isCordova()) {

                    if (this.$public.notNull(appInBrowser)) {
                        let loop = null;

                        appInBrowser.addEventListener('message', function(...args) {

                            if (self.$public.notNull(args) && self.$public.notNull(args[0])) {
                                let msgObj = args[0];
                                if (msgObj.type === 'message') {
                                    if (self.$public.notNull(msgObj.data) &&
                                        self.$public.notNull(msgObj.data.message)){

                                        if (msgObj.data.message.indexOf('booking-confirm') >= 0) {
                                            //加入到行事曆
                                            if (self.$public.notNull(self.storeInfo)) {
                                                self.onBookingCompleted(msgObj.data.message, self.storeInfo.brandName);
                                            }
                                            appInBrowser.close();

                                        } else if (msgObj.data.message.indexOf('close') >= 0) {
                                            appInBrowser.close();
                                        }
                                    }
                                }
                            }
                        }, false);

                        //監聽 '載入完成' 事件
                        appInBrowser.addEventListener('loadstop', function(event) {
                            //取得訂位網頁左上角的'關閉'按鈕，並植入關閉的方式
                            appInBrowser.executeScript({
                                code: "document.getElementById('closeBtn').addEventListener(\"click\",function(e){" +
                                    "const message = {message: 'close'};" +
                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(message));" +
                                    "},false);"
                            });

                            //setInterval，會一直取得網頁位址，直到位址內有 booking-confirm才會停止
                            loop = setInterval(function() {

                                appInBrowser.executeScript(
                                    {
                                        //此寫法表示，把 location.href傳給 function( values )，注意 values爲陣列
                                        code: "location.href;"
                                    },
                                    function( values ) {

                                        //植入另一段 javascript
                                        if (self.$public.notNull(values) && self.$public.notNull(values[0]) &&
                                            values[0].indexOf('booking-confirm') >= 0) {

                                            //停止迴圈
                                            clearInterval( loop );

                                            //尋找 id爲 addCalender的元件(前端要先寫好)，植入按下按鈕要觸發的動作
                                            //按下後會傳回目前網頁位址，以 message的形式發送給 inAppBrowser套件
                                            appInBrowser.executeScript({
                                                code:
                                                    "document.getElementById('addCalender').addEventListener(\"click\",function(e){" +
                                                    "const messageObj = { message: location.href};" +
                                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(messageObj));" +
                                                    "}, false);"+
                                                    "document.getElementById('closeBtn').addEventListener(\"click\",function(e){" +
                                                    "const message = {message: 'close'};" +
                                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({message}));" +
                                                    "},false);"
                                            });
                                        }
                                    }
                                );
                            }, 1000);

                        }, true);
                    }
                }

                // self.onBookingCompleted('https://booking-test.oinapp.com/app/39/booking-confirm?id=OKZRa5Hhec1J8j4kpptQLJpnWX4%3D&store=健康旗艦店&date=2021-11-28&time=18%3A00&result=success');
            },

            /** 訂位完成時 */
            onBookingCompleted: function (params, brandName) {
                //訂位完成後會跳到 http://xxx.xxx:8082/app/booking-confirm?id=paFW43Obqq%2BNmahwWtXCWTDyH0A%3D&store=Gottone%20%E8%94%AC%E9%A3%9F&date=2021-11-17&time=12%3A30&result=success
                let success = false;
                let date = '', storeName = '';
                let year = 0, month = 0, day = 0, hour = 0, minute = 0;


                if (this.$public.notNull(params) && params.indexOf('booking-confirm') >= 0) {
                    let decodeUrl = decodeURIComponent(params);

                    decodeUrl.split('&').forEach(
                        //解析網址
                        element => {
                            if (element.indexOf('result=') >= 0) {
                                success = element.indexOf('success') >= 0;

                            } else if (element.indexOf('date=') >= 0) {
                                date = element.substr(element.indexOf('date=')+5);

                                let bookingDate = new Date(date);
                                year = bookingDate.getFullYear();
                                month = bookingDate.getMonth();
                                day = bookingDate.getDate();

                            } else if (element.indexOf('time=') >= 0) {
                                let time = element.substr(element.indexOf('time=')+5);
                                let timeSplit = time.split(':');
                                if (this.$public.notNull(timeSplit)) {
                                    hour = Number(timeSplit[0]);
                                    minute = Number(timeSplit[1]);
                                }

                            } else if (element.indexOf('store=') >= 0) {
                                storeName = element.substr(element.indexOf('store=')+6);
                            }
                        }
                    )
                }

                if (success) {
                    //加入行事曆
                    this.$public.addCalendarEvent(this.$http.getOS(), `${brandName} ${storeName} 訂位`, year, month, day, hour, minute);

                } else {
                    alert("無法將訂位行程加入行事曆");
                }

            },

            loadBookingRecord: function (storeId) {
                let self = this;
                let routerName = "BookRecord"
                let dataToken = self.$crypto.objectToURIComponent({
                    usedType: routerName,
                    userId: self.userId,
                    storeId: storeId,
                })

                self.$router.push({name: routerName, query: {'dataToken': dataToken}})
            },

            /** 替換影片 url */
            changeVideoUrl: function (url) {
                //替換 i-frame 的連結
                // let watchKey = 'watch?v=';
                // let video = 'https://www.youtube.com/embed/69arSuOXsRE?controls=0';
                // this.videoUrl = 'https://www.youtube.com/watch?v=v_RT8hLUDuo';
                // this.videoUrl = '<iframe width="560" height="315" src="'+ video +'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"/>';

                if (this.$public.notNull(url) && url !== "") {
                    this.videoUrl = this.$public.getEmbedVideoUrl(url);
                    let frame = document.getElementById('store-video-frame');
                    if (this.$public.notNull(frame)) {
                        frame.src = this.videoUrl;
                    }
                }
            },

            /** 是否顯示影片 url */
            isShowVideo: function (videoUrl) {
                return (this.$public.notNull(videoUrl) && videoUrl !== "")
            },

            /** google地圖url分析，爲避免店家輸入的url打開後效果不統一，一律先分析再從公用函式開啓頁面 */
            analyzeGoogleMapUrl: function (url) {
                if (this.$public.notNull(url) && url !== '') {
                    let signSplit = [];      //以 &分隔出來的 url區段，要找出 ?v= 後面的字串，才是真的 key
                    signSplit = url.split(`/`);

                    //如果有 &字串
                    if (signSplit.length > 0) {
                        signSplit.forEach( (item, index) => {
                            if (item !== '' ) {
                                if(item.indexOf(`@`) > -1) {
                                    //GPS
                                    let commaSplit = [];
                                    commaSplit = item.split(`,`);
                                    let gpsData = this.analyzeGps(commaSplit);
                                    if (this.$public.notNull(gpsData)) {
                                        this.googleMapLat = gpsData.lat;
                                        this.googleMapLng = gpsData.lng;
                                    }

                                } else if (item.indexOf(`data=`) > -1) {
                                    //店家資訊
                                    let commaSplit = [];
                                    commaSplit = item.split(`?`);
                                    this.googleMapStoreInfoData = this.analyzeStoreInfo(commaSplit);

                                }
                            }
                        });
                    }
                }
            },

            /** 分析 GPS座標 */
            analyzeGps: function (stringSplit) {
                let result = null;

                if (this.$public.notNull(stringSplit) && stringSplit.length > 1) {
                    let lat = stringSplit[0].replace('@', '');  //緯度
                    let lng = stringSplit[1];           //經度
                    result = {lat, lng};
                }

                return result;
            },
            /** 分析商店資料 */
            analyzeStoreInfo: function (stringSplit) {
                let data = '';       //
                if (this.$public.notNull(stringSplit) && stringSplit.length > 0) {
                    data = stringSplit[0].replace('data=', '');
                }

                return data;
            },

            /** 點擊電話按鈕 */
            onClickCallBtn: function (tel) {
                this.analytics.sendEvent(Analytics.EVENTS.MAKE_A_CALL);
                this.$public.callTel(tel);
            },

            /** 點擊地點按鈕 */
            onClickLocationBtn: function () {
                this.analytics.sendEvent(Analytics.EVENTS.QUERY_ADDRESS);
                //開啓地圖
                if (this.$public.notNull(this.storeInfo.googleMapUrl) && this.googleMapLat > 0 && this.googleMapLng > 0) {
                    //爲避免店家輸入的url打開後效果不統一，一律先分析再從公用函式開啓頁面
                    this.$public.openMap(this.googleMapLat, this.googleMapLng, this.googleMapStoreInfoData);
                } else {
                    this.$public.openMap(this.storeInfo.lat, this.storeInfo.lng);
                }
            },

            /** 點擊推薦商品圖片 */
            onClickProposeItem(mealId) {
                if(!this.isWeb){
                    this.$router.push({name: 'MealInfo',query:{mealId: mealId, type : 'store'}})
                }else {
                    //單店網頁版用
                    this.dataTokenWeb = {mealId: mealId, type : 'store'};
                    this.isTypeWeb = 'MealInfo'
                    this.isShowPullDown = true
                }
            },

            /** 點擊功能按鈕 */
            onClickFuncBtn: function (func, params) {

                //不需要登入的功能
                if (func === 'usefulStore') {
                    //門市資訊
                    //發出GA事件記錄
                    this.sendClickFuncGAEvent("click_門市資訊");
                    if(!this.isWeb){
                        this.$router.push({name: 'UsefulStoreList', query:{type: 'brand', id: params.brandId}});
                    }else {
                        //單店網頁版用
                        this.dataTokenWeb = {type: 'brand', id: params.brandId}
                        this.isTypeWeb = 'UsefulStoreList'
                        this.isShowPullDown = true
                    }

                    return;
                }else if(func ==='bulletin'){
                    //公告
                    //發出GA事件記錄
                    this.sendClickFuncGAEvent("click_公告");
                    this.goBulletin(params);
                    return;
                }else if(func ==='column'){
                    //專欄
                    //發出GA事件記錄
                    this.sendClickFuncGAEvent("click_專欄");
                    this.$router.push({name: 'ArticleList', query:{id: this.storeInfo.id}});
                    return;
                }else if(func ==='question'){
                    //常見問題
                    //發出GA事件記錄
                    this.sendClickFuncGAEvent("click_常見問題");
                    this.$router.push({name: 'Question', params: {storeId: this.storeInfo.id.toString()}});
                    return;
                }

                if (!this.isLogin) {
                    this.isShowLogin = true;
                } else {
                    if (this.isMember !== undefined && !this.isMember) {
                        this.showJoinMemberDialog("您尚未成爲此品牌會員", "加入會員能使用此功能，是否成爲此品牌的會員？", true);

                    } else {
                        switch(func) {
                            case 'comment': //評論
                                this.showToast('本功能尚未開放');
                                break;
                            case 'reflect': //意見反映
                                // this.showToast('本功能尚未開放');
                                this.$router.push({name: 'Feedback', query:{storeId: this.id}})
                                break;
                            case 'order':   //點餐
                                //發出GA事件記錄
                                this.sendClickFuncGAEvent("click_點餐");
                                this.$router.push({name: 'OrderList', query:{id: this.storeInfo.id}});
                                break;
                            case 'waiting': //候位
                                //發出GA事件記錄
                                this.sendClickFuncGAEvent("click_候位");
                                this.$router.push({name: 'OrderList', query:{id: this.storeInfo.id}});
                                // this.showToast('本功能尚未開放');
                                break;
                            case 'booking': //訂位
                                //發出GA事件記錄
                                this.sendClickFuncGAEvent("click_訂位");
                                this.loadBooking();
                                break;
                            case 'bookingRecord': //訂位記錄
                                //發出GA事件記錄
                                this.sendClickFuncGAEvent("click_訂位記錄");
                                this.loadBookingRecord(this.id);
                                break;
                            case 'reserve': //預訂
                              //發出GA事件記錄
                              this.sendClickFuncGAEvent("click_預訂");
                              this.loadReserve();
                              break;
                            default:
                                this.showToast('本功能尚未開放');
                                break;
                        }
                    }
                }
            },

            /** 跳到公告頁 */
            goBulletin: function (params) {
                if (this.$public.notNull(params) && this.$public.notNull(params.itemId)) {
                    this.$router.push({name: 'Bulletin', query:{storeId: this.storeInfo.id, itemId: params.itemId}});
                } else {
                    this.$router.push({name: 'Bulletin', query:{storeId: this.storeInfo.id}});
                }
            },

            showBusinessTime: function (item) {
                if (item !== "休息日") {
                    let showTime = "";
                    item.forEach(function (value) {
                      showTime = showTime + value + '<br/>';
                    })
                    return showTime.slice(0, showTime.length-5);
                } else {
                    return "休息日"
                }
            },

            /** 點擊 優惠卷 更多 */
            onClickCouponLink : function() {
                if (!this.isLogin) {
                    this.isShowLogin = true
                } else {
                    this.$router.push({name:'CouponList'});
                }
            },

            /** 點擊 優惠券 */
            onClickCouponDetail : function(item) {
                if (!this.isLogin) {
                    this.isShowLogin = true
                } else {
                    this.$router.push({name:'CouponDetail', query:{couponId: item.couponId}});
                }
            },
            /** 點擊 優惠活動 */
            onClickTicketDetail : function(item) {
              if (!this.isLogin) {
                this.isShowLogin = true
              } else {
                let obj = {
                  "id": item.id,
                  "ticketTypeId": item.ticketTypeId,
                }

                let encryptedString = this.$crypto.encryptObject(obj);
                this.$router.push({name: 'TicketDetail', query: {'p': encryptedString}});
              }
            },

            /** 點擊 加入會員 */
            onClickAddMember : function() {
                if (this.isMember !== undefined) {
                    if (this.isMember) {
                        this.$store.commit(mutationTypes.SHOW_TOAST, '已經加入該店會員');
                    } else {

                        this.showJoinMemberDialog("加入會員", "是否同意成爲品牌會員？", true);
                    }
                }
            },

            /** 是否已經加入品牌會員 */
            isJoinBrandMember: function(brandId) {
                let self = this;
                self.isLoading = true;
                return new Promise(function(resolve) {
                    self.$http.fetchWithAuth`IsAddBrand${{
                        id: brandId
                    }} ${json => {
                        self.isMember = json.status;
                        self.isLoading = false;
                        //完成
                        resolve();
                    }}`;
                });
            },

            /** 加入品牌會員 */
            addBrandMember: function(brandId) {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`AddBrand${{
                        id: brandId
                    }} ${json => {
                        self.isMember = json.status;

                        if (json.status) {
                            const analytics = Analytics.getInstance(self.$route, self.$route.name);
                            analytics.sendEvent(Analytics.EVENTS.JOIN_MEMBER, {
                                brandId: brandId,
                                storeId: self.storeInfo.id,
                                page: self.$route.name,
                            });

                            //完成
                            resolve();
                        } else {
                            reject('無法加入會員:' + json.message);
                        }
                    }}`;
                });
            },

            /** 取得 user在店家要顯示的 Tag */
            getUserStoreTag: function(storeId) {
                let self = this;
                self.isLoading = true;
                return new Promise(function(resolve) {
                    self.$http.fetchWithAuth`GetStoreTag${{
                        id: storeId
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            self.tagList = json.data;
                        }
                        self.isLoading = false;
                        //完成
                        resolve();
                    }}`;
                });
            },

            showToast:function(message) {
                this.$store.commit(mutationTypes.SHOW_TOAST, message);
            },
            announcementApi() {
              this.showToast('此功能尚未開放');
              // let self = this;
              // self.isLoading = true;
              // this.$http.fetchWithAuth`GetAnnouncementQueryAllList${{
              //   'storeId':  self.id,
              //   'status':   1
              // }}
              //   ${json => {
              //   self.isLoading = false;
              // }}`;
            },

            /** 發出點擊功能鈕的 GA事件 */
            sendClickFuncGAEvent: function (eventName) {
                if (this.$public.notNull(this.storeInfo)) {
                    let brandName = this.$public.notNull(this.storeInfo.brandName)? this.storeInfo.brandName:'';
                    let storeName = this.$public.notNull(this.storeInfo.name)? this.storeInfo.name:'';
                    let eventTitle = this.$public.getClearStrRegExp(`${eventName}_${brandName}_${storeName}`.replace(/ /g, ""));
                    this.$public.addGAEventLog(eventTitle, {store_name: storeName.replace(/ /g, "")});
                } else {
                    this.$public.addGAEventLog(`${eventName.replace(/ /g, "")}`, {store_name: ""});
                }
            },

            /** 外送詳細開合 */
            isOpen: function() {
                document.getElementsByClassName('takeout-list')[0].classList.toggle("open")
            },

            /** icon是否爲空？ */
            isNoteIconEmpty: function(noteIcon) {
                return (this.$public.notNull(noteIcon) && noteIcon !== '');
            },

            /** 是否顯示備註 */
            isShowRemark: function(storeInfo) {
                let result = false;
                if (this.$public.notNull(storeInfo) && this.$public.notNull(storeInfo.noteStatus)) {
                    result = storeInfo.noteStatus &&
                        (this.$public.notNull(storeInfo.title) && storeInfo.title !== '') &&
                        (this.$public.notNull(storeInfo.noteAry)) &&
                        storeInfo.noteAry.length > 0;
                }
                return result ;
            },
            /** 備註 */
            getRemark: function(storeInfo) {
                let result = '';
                if (storeInfo.noteAry !== undefined &&
                    storeInfo.noteAry !== null &&
                    storeInfo.noteAry.length > 0) {
                    storeInfo.noteAry.forEach(function (value) {
                        if (value !== '') {
                            result = result + '<p>'+ value ;
                        }
                    })
                }
                return result;
            },

            /** 是否顯示營業時間 */
            isShowBusinessHours: function(storeInfo) {
                let result = false;
                if (this.$public.notNull(storeInfo) && this.$public.notNull(storeInfo.isShowBusiness)) {
                    result = (storeInfo.isShowBusiness === 1) && this.$public.notNull(storeInfo.businessHours) ;
                }
                return result ;
            },

            /** 是否顯示關於我們 */
            isShowAbout: function(storeInfo) {
                let result = false;
                if (this.$public.notNull(storeInfo) && this.$public.notNull(storeInfo.description)) {
                    result = storeInfo.descriptionStatus && (storeInfo.description !== '');
                    let msg = storeInfo.description.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
                    msg = msg.replace(/&nbsp;/ig, ''); //去掉&nbsp
                    this.aboutText = msg
                }
                return result ;
            },

            /** 載圖錯誤 */
            onImgError: function() {
                this.isNoteIconError = true;
            },

            /** 開啓預訂網頁 */
            loadReserve:function(){
                let dataToken = this.$crypto.objectToURIComponent({
                    usedType:    "openReserveWeb",
                    storeToken:  this.$crypto.encryptText(String(this.id)),
                    userToken:   this.$auth.getAdminToken(),
                    isCordova:   this.$public.isCordova(),
                })

                let urlSet = process.env.VUE_APP_RESERVE_HOST + "?dataToken=" +dataToken;
                // this.$public.openUrlWithCloseBtn(urlSet);

                let self = this;
                let browser = this.$public.isCordova()? window.cordova.InAppBrowser: window;
                //使用 _system的話會呼叫 app外部的 browser來開網頁
                let appInBrowser = browser.open(urlSet, '_blank', 'toolbar=no,location=no' + self.$http.browserOpenFeatures());

                // 注意，這一段是針對使用 InAppBrowser這個套件專用的方法
                //如果是 cordova開啓，就植入 javascript持續取得網頁網址 location.href，
                //直到轉成訂位成功的頁面，再將另一段 javascript植入加入行事曆按鈕中，發射 message給 app接收
                if (this.$public.isCordova()) {

                    if (this.$public.notNull(appInBrowser)) {
                        let loop = null;

                        appInBrowser.addEventListener('message', function(...args) {

                            if (self.$public.notNull(args) && self.$public.notNull(args[0])) {
                                let msgObj = args[0];
                                if (msgObj.type === 'message') {
                                    if (self.$public.notNull(msgObj.data) &&
                                        self.$public.notNull(msgObj.data.message)){

                                        if (msgObj.data.message.indexOf('booking-confirm') >= 0) {
                                            //加入到行事曆
                                            self.onReserveCompleted(msgObj.data.message);
                                            appInBrowser.close();

                                        } else if (msgObj.data.message.indexOf('close') >= 0) {
                                            appInBrowser.close();
                                        }
                                    }
                                }
                            }
                        }, false);

                        //監聽 '載入完成' 事件
                        appInBrowser.addEventListener('loadstop', function(event) {
                            //取得訂位網頁左上角的'關閉'按鈕，並植入關閉的方式
                            appInBrowser.executeScript({
                                code: "document.getElementById('closeBtn').addEventListener(\"click\",function(e){" +
                                    "const message = {message: 'close'};" +
                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(message));" +
                                    "},false);"
                            });

                            //setInterval，會一直取得網頁位址，直到位址內有 booking-confirm才會停止
                            loop = setInterval(function() {

                                appInBrowser.executeScript(
                                    {
                                        //此寫法表示，把 location.href傳給 function( values )，注意 values爲陣列
                                        code: "location.href;"
                                    },
                                    function( values ) {

                                        //植入另一段 javascript
                                        if (self.$public.notNull(values) && self.$public.notNull(values[0]) &&
                                            values[0].indexOf('booking-confirm') >= 0) {

                                            //停止迴圈
                                            clearInterval( loop );

                                            //尋找 id爲 addCalender的元件(前端要先寫好)，植入按下按鈕要觸發的動作
                                            //按下後會傳回目前網頁位址，以 message的形式發送給 inAppBrowser套件
                                            appInBrowser.executeScript({
                                                code:
                                                    "document.getElementById('addCalender').addEventListener(\"click\",function(e){" +
                                                    "const messageObj = { message: location.href};" +
                                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(messageObj));" +
                                                    "}, false);"+
                                                    "document.getElementById('closeBtn').addEventListener(\"click\",function(e){" +
                                                    "const message = {message: 'close'};" +
                                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({message}));" +
                                                    "},false);"
                                            });
                                        }
                                    }
                                );
                            }, 1000);

                        }, true);
                    }
                }

            },

            /** 預訂完成時 */
            onReserveCompleted: function (params) {
                //訂位完成後會跳到 http://xxx.xxx:8082/app/booking-confirm?id=paFW43Obqq%2BNmahwWtXCWTDyH0A%3D&store=Gottone%20%E8%94%AC%E9%A3%9F&date=2021-11-17&time=12%3A30&result=success
                let success = false;
                let date = '', eventName = '', brandName = '';
                let year = 0, month = 0, day = 0, hour = 0, minute = 0;


                if (this.$public.notNull(params) && params.indexOf('booking-confirm') >= 0) {
                    let decodeUrl = decodeURIComponent(params);

                    decodeUrl.split('&').forEach(
                        //解析網址
                        element => {
                            if (element.indexOf('result=') >= 0) {
                                success = element.indexOf('success') >= 0;

                            } else if (element.indexOf('date=') >= 0) {
                                date = element.substr(element.indexOf('date=')+5);

                                let bookingDate = new Date(date);
                                year = bookingDate.getFullYear();
                                month = bookingDate.getMonth();
                                day = bookingDate.getDate();

                            } else if (element.indexOf('time=') >= 0) {
                                let time = element.substr(element.indexOf('time=')+5);
                                let timeSplit = time.split(':');
                                if (this.$public.notNull(timeSplit)) {
                                    hour = Number(timeSplit[0]);
                                    minute = Number(timeSplit[1]);
                                }

                            } else if (element.indexOf('event=') >= 0) {
                                eventName = element.substr(element.indexOf('event=')+6);

                            } else if (element.indexOf('brand=') >= 0) {
                                brandName = element.substr(element.indexOf('brand=')+6);
                            }
                        }
                    )
                }

                if (success) {
                    //加入行事曆
                    this.$public.addCalendarEvent(this.$http.getOS(), `${brandName} ${eventName}預訂`, year, month, day, hour, minute);

                } else {
                    alert("無法將預訂行程加入行事曆");
                }

            },

            //關閉下滑彈窗
            closePullDown(){
                this.isShowPullDown = false
            },
        },
    }
</script>

<style lang="less" scoped src="../../less/store.less"/>
<style lang="less" scoped>
    /deep/.read-more{
        display: block;
    }
</style>